import { useEffect, useState, useCallback } from "react";
import { api, apiError } from "@/lib/api";
import { useRefresh } from "@/context/RefreshContext";

export function useApi(path, { enabled = true } = {}) {
  const { tick } = useRefresh();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!path || !enabled) { setLoading(false); return; }
    setError(null);
    try {
      const res = await api.get(path);
      setData(res.data);
    } catch (e) {
      setError(apiError(e));
    } finally {
      setLoading(false);
    }
  }, [path, enabled]);

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [path, tick, enabled]);

  return { data, loading, error, reload: load };
}
